import { clean, initialize } from '../../../store/modules/headlines'
import { componentDidMount, componentWillUnmount } from '../../Lifecycles'
import Headlines from './Headlines'
import { compose } from 'ramda'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  isFetching: state.headlines.isFetching,
  headlines: state.headlines.headlines,
  error: state.headlines.error,
  locale: state.router.locale,
  viewport: state.viewport.viewport,
})

const mapDispatchToProps = dispatch => ({
  initialize: compose(dispatch, initialize),
  clean: compose(dispatch, clean),
})

// didMount :: Props -> Action.FETCH_CONTENTS
const didMount = ({ initialize, id }) => initialize(id, true)

// willUnmount :: Props -> Action.CLEAN
const willUnmount = ({ clean }) => clean()

// lifecycles :: React.Component -> React.Component
const lifecycles = compose(
  componentDidMount(didMount),
  componentWillUnmount(willUnmount),
)(Headlines)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(lifecycles)
